


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class DeleteAccountModal extends Vue {
    title = "ユーザー登録削除";

    private get message(){
        return "ユーザー登録を削除すると、下記の機能がご利用いただけなくなります。\n"
        + "削除を行いますか？\n\n"
        + "・ラベル屋さんクラウドの利用（保存データ削除）\n"
        + "・各社クラウドシトレージとの連携\n"
        + "・SNS連携機能";
    }

    private onOk(){
        this.$emit("doDeleteAccount");
        this.$emit("close");
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
